import Button, { ButtonType } from "@/app/(components)/generics/Button/Button";
import IconMagnifyingGlass from "@/app/(components)/generics/Icons/IconMagnifyingGlass";
import CircleLoader from "@/app/(components)/generics/loaders/CircleLoader/CircleLoader";
import { Tooltip, TooltipPosition, TooltipType } from "@/app/(components)/generics/Tootlip/Tooltip";
import { useBrand } from "@/app/(components)/specifics/wrappers/BrandProvider/BrandProvider";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { ImportedBaseAvailability } from "@/app/types/imported-profile/ImportedBaseSearch";
import { roundedAvailable } from "./ProspectSources.logic";
import styles from "./ProspectSources.module.css";

type Props = {
  data?: ImportedBaseAvailability;
  isRunning?: boolean;
  onOpen?: () => void;
};

export default function ImportedBaseButton(props: Props) {
  const { data, isRunning = false, onOpen } = props;
  const T = useT();
  const brand = useBrand();

  const matching = data?.matching ?? 0;
  const hasKeywords = !data || data.keywords.length > 0;
  const isDisabled = !!data && (!hasKeywords || (data.known && matching === 0));

  const button = (
    <Button
      isLink={false}
      small={true}
      type={ButtonType.PRIMARY}
      beforeIcon={
        isRunning ? (
          <CircleLoader size={14} color="var(--color-white-1)" strokeWidth={2} />
        ) : (
          <IconMagnifyingGlass />
        )
      }
      text={
        <span className={styles.poolLabel}>
          {T(brand ? TKey.IMPORTED_BASE_BUTTON_COMPANY : TKey.IMPORTED_BASE_BUTTON)}
          {!!data?.known && matching > 0 && (
            <span className={styles.poolCount}>+{roundedAvailable(matching)}</span>
          )}
        </span>
      }
      onClick={onOpen}
      disabled={isDisabled}
    />
  );

  // Sans critères, la carte au-dessus porte déjà "Génère mes critères": une infobulle qui redit
  // la même chose à côté est du bruit.
  if (!isDisabled || !hasKeywords) {
    return button;
  }

  return (
    <Tooltip
      portal={true}
      type={TooltipType.GREEN}
      position={TooltipPosition.BOTTOM}
      content={T(
        data && data.candidates > 0
          ? TKey.IMPORTED_BASE_DISABLED_NO_MATCH
          : TKey.IMPORTED_BASE_DISABLED_NOTHING_NEW,
      )}
      trigger={<span className={styles.poolDisabled}>{button}</span>}
    />
  );
}
